import { supplierIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const deleteSupplier = {
  name: "deleteSupplier" as const,
  input: z.object({ supplierId: supplierIdFormat.schema }),
  output: z.object({ success: z.boolean() }),
};
